import { Component, OnInit, Renderer2, Optional, Inject, PLATFORM_ID, OnDestroy, ElementRef } from '@angular/core';
import { isPlatformServer } from '@angular/common';
import { RESPONSE } from '@nguniversal/express-engine/tokens';
import { Response } from 'express';
import { ServerError } from 'src/Exceptions/ServerError';
import { Observable, Subject } from 'rxjs';

import { LangService } from '../../services/lang.service';
import { Lang } from 'src/app/models/lang';
import { Strings } from '../../const/strings';
import { CarCollection } from '../../models/car';
import { CarService } from '../../services/car.service';
import { catchError, takeUntil, tap } from 'rxjs/operators';
import { SsrTransferStateService } from '../../services/ssr-transfer-state.service';

@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.scss']
})
export class NotFoundComponent implements OnInit, OnDestroy {

  carRankingCollection$: Observable<CarCollection>;
  destroy$: Subject<boolean> = new Subject<boolean>();
  appUrl: string;
  lang: Lang;
  strings = Strings;

  constructor(
    @Optional() @Inject(RESPONSE) private response: Response,
    @Inject(PLATFORM_ID) private platformId: object,
    private renderer: Renderer2,
    private elementRef: ElementRef,
    private langService: LangService,
    private carService: CarService,
    private ssrTransferState: SsrTransferStateService,
  ) { }

  ngOnInit() {
    this.appUrl = this.langService.getAppUrl();
    this.lang = this.langService.getCurrentLang();
    this.setBodyClassName();
    this.fetchRankingList();
    if (isPlatformServer(this.platformId) && this.response) {
      this.response.status(404);
    }
  }

  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }

  private setBodyClassName() {
    if (typeof document === 'undefined') {
      return;
    }
    this.renderer.addClass(document.body, 'notfound_page_body');
    if (this.lang === 'en') {
      this.renderer.addClass(document.body, 'lang_en');
    }
  }

  private fetchRankingList() {
    this.carRankingCollection$ = this.ssrTransferState.get(
      this.elementRef.nativeElement.tagName + '-CAR_RANKING',
      this.carService.fetchRanking(this.lang)
    )
      .pipe(
        takeUntil(this.destroy$),
        tap(carCollection => {
          // tslint:disable-next-line: no-string-literal
          if (carCollection['status'] !== undefined && carCollection['status'] === 500) {
            // 500 Internal Server Error
            throw new ServerError('Internal Server Error');
          }
        }),
        catchError(error => {
          if (isPlatformServer(this.platformId) && this.response) {
            this.response.status(503);
          }
          throw new ServerError(error);
        })
      );

  }

}
